(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.useQuery = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.useQuery = void 0;
  // A custom hook that builds on useLocation to parse

  // the query string for you.
  var useQuery = function useQuery() {
    var search = window.location.search;
    return (0, _react.useMemo)(function () {
      return new URLSearchParams(search);
    }, [search]);
  };
  _exports.useQuery = useQuery;
});